// pages/ProductNewPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useSnackbar } from '../contexts/SnackbarProvider';
import axiosInstance from '../utils/axiosInstance';
import { prepareProductPayload } from '../utils/prepareProductPayload';
import ProductForm from '../components/ProductForm';
import { Typography, Button, Snackbar, Alert } from "@mui/material";
import { Sync } from "@mui/icons-material";

const ProductNewPage = ({ hasLimit }) => {
    const { showSnackbar } = useSnackbar();
    const [dataset, setDataset] = useState();
    const [imageFiles, setImageFiles] = useState([]);
    const [newImages, setNewImages] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState();
    const [variants, setVariants] = useState([]);
    const [optionTypes, setOptionTypes] = useState([]);
    const [specs, setSpecs] = useState([]);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
    });
    const navigate = useNavigate();
    const { register, handleSubmit, setValue, control, setError, clearErrors, formState: { errors } } = useForm();

    // 商品の新規登録処理
    const onSubmit = async (data) => {
        try {
            const payload = prepareProductPayload({
                data,
                dataset,
                imageFiles,
                selectedCategory,
                variants,
                specs,
            });
            const res = await axiosInstance.post('/product/new', payload, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            showSnackbar(res?.data?.message || '商品情報が登録されました', 'success');
            setVariants([]);
            setOptionTypes([]);
            navigate(`/products/${res?.data?.product_id}`);
        } catch (err) {
            if (process.env.NODE_ENV === 'development') {
                console.error(err);
            }
            showSnackbar(err?.response?.data?.message || '商品情報の登録に失敗しました。', 'error');
        }
    };

    return (
        <>
            <Typography variant="h1" component="h1">商品の新規登録</Typography>
            <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
                <ProductForm
                    hasLimit={hasLimit}
                    dataset={dataset}
                    imageFiles={imageFiles} setImageFiles={setImageFiles}
                    newImages={newImages} setNewImages={setNewImages}
                    selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory}
                    variants={variants} setVariants={setVariants}
                    optionTypes={optionTypes} setOptionTypes={setOptionTypes}
                    specs={specs} setSpecs={setSpecs}
                    register={register} errors={errors} control={control} setValue={setValue}
                />
                <div className='button-row'>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        startIcon={<Sync />}
                    >
                        登録する
                    </Button>
                </div>
            </form>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
            >
                <Alert
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default ProductNewPage;
